import React from 'react'
import moment from 'moment'
import _ from 'underscore'

export default class AdminUsers extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      users : [],
    };
		// websocket connections
    this.sockets = [];
  }

  componentDidMount() {
		// Get Users
    api('/user/_all')
      .then( (res) => {
        if (_.isArray(res)) {
          this.setState({users: res})
        }
      })
  }

	componentWillUnmount() {
    for (var i = 0; i < this.sockets.length; i++) {
      this.sockets[i].close();
    };
    delete this.sockets;
	}

  handlePermissionChange(e, user) {
    const permission = e.target.name
    if (_.contains(user.permissions, permission)) {
      // remove permission
      api('/user/'+user.username+'/permissions/'+permission, { method: 'DELETE' })
        .then( (res) => {
          if (res && res.permissions) {
            _.findWhere(this.state.users, {username: res.username}).permissions = res.permissions
            this.forceUpdate()
          } else {
            console.log(res)
            if (res.detail) raiseAlert(res.detail)
          }
        }).catch( (err) => { console.log(err) })
    } else {
      // add permission
      api('/user/'+user.username+'/permissions/'+permission, { method: 'PUT' })
        .then( (res) => {
          if (res && res.permissions) {
            _.findWhere(this.state.users, {username: res.username}).permissions = res.permissions
            this.forceUpdate()
          } else {
            console.log(res)
            if (res.detail) raiseAlert(res.detail)
          }
        }).catch( (err) => { console.log(err) })
    }
    console.log(e.target.name, user)
  }

  render() {
    return (
      <div className="row" style={{marginTop:"2em"}}>
        <div className="col-xs-offset-2 col-xs-8">
        <div className="row" style={{marginBottom:'1em'}}>
        Users Management
        </div>
            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th style={{ maxWidth: '50em'}}></th>
                        <th style={{ width: '20em'}}></th>
                        <th width="50%"></th>
                    </tr>
                </thead>
                <tbody>{
                	_.map(_.sortBy(this.state.users, (usr) => usr.username), (usr) => {
      	        		return <tr key={usr.user_id} className="clickable"
                               style={{height:'5em'}}
                               >
    	        			<td style={{verticalAlign: 'middle'}}><div>
                      <div>
                        <span className="cellPrice" style={{fontWeight: 'bold', fontSize: 12}}>{ usr.username }</span>
                        { (_.contains(usr.permissions, 'user_admin') ? <span className="ui teal label">Admin</span> : '' ) }
                        {(usr.username === localStorage.username ? <span className="ui left pointing label">It's You!</span> : '')}
                      </div>
                      <div style={{marginTop: '0.2em'}}>{ (usr.first_name === usr.last_name ? usr.first_name : usr.first_name + ' ' + usr.last_name) }</div>
                    </div></td>
    	        			<td style={{verticalAlign: 'middle', textAlign: 'center'}}>{ usr.role }</td>
    	        			<td style={{verticalAlign: 'middle'}}>
                      <div className={"ui checkbox" + (_.contains(usr.permissions, 'enabled') ? ' checked' : '')} style={{marginRight:'1em'}}>
                        <input type="checkbox" checked={_.contains(usr.permissions, 'enabled')} name="enabled" onChange={(e) => this.handlePermissionChange(e, usr)} />
                        <label>Enabled</label>
                      </div>
                      <div className={"ui checkbox" + (_.contains(usr.permissions, 'user_admin') ? ' checked' : '')} style={{marginRight:'1em'}}>
                        <input type="checkbox" checked={_.contains(usr.permissions, 'user_admin')} name="user_admin" onChange={(e) => this.handlePermissionChange(e, usr)} />
                        <label>User Admin</label>
                      </div>
                      <div className={"ui checkbox" + (_.contains(usr.permissions, 'order_create') ? ' checked' : '')} style={{marginRight:'1em'}}>
                        <input type="checkbox" checked={_.contains(usr.permissions, 'order_create')} name="order_create" onChange={(e) => this.handlePermissionChange(e, usr)} />
                        <label>Order:Create</label>
                      </div>
                    </td>
    	        		</tr>
    	        	})
            	}</tbody>
            </table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin_users.jsx